// Mace PDP: tabs with recommendations (snippets/mba-pdp-tabs.liquid) + mini product rows
if (!customElements.get('mba-pdp-tabs')) {
  customElements.define(
    'mba-pdp-tabs',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll('[data-tab]');
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab.dataset.tab)));
        Promise.all([...this.querySelectorAll('[data-intent]')].map((pane) => this.load(pane))).then(() => this.tidy());
        this.tidy();
        this.addEventListener('click', (e) => this.onClick(e));
      }

      async load(pane) {
        const url = `${this.dataset.url}?product_id=${this.dataset.productId}&limit=3&intent=${pane.dataset.intent}&section_id=mba-pdp-recs`;
        try {
          const html = await (await fetch(url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const result = doc.querySelector('.mba-recs-result');
          if (result) pane.innerHTML = result.innerHTML;
        } catch (e) {
          /* keep pane empty */
        }
      }

      tidy() {
        // Hide tabs without products; show the first remaining one
        let first = null;
        this.tabs.forEach((tab) => {
          const pane = this.querySelector(`[data-pane="${tab.dataset.tab}"]`);
          const has = pane.querySelector('[data-mini]');
          tab.hidden = !has && !pane.dataset.intent;
          if (pane.dataset.intent && pane.dataset.loaded === undefined) return;
          if (has && !first) first = tab.dataset.tab;
        });
        this.querySelectorAll('[data-intent]').forEach((p) => (p.dataset.loaded = '1'));
        this.tabs.forEach((tab) => {
          const pane = this.querySelector(`[data-pane="${tab.dataset.tab}"]`);
          if (pane.dataset.loaded && !pane.querySelector('[data-mini]')) tab.hidden = true;
        });
        const visible = [...this.tabs].filter((t) => !t.hidden);
        this.hidden = visible.length === 0;
        const active = [...this.tabs].find((t) => t.classList.contains('is-active') && !t.hidden);
        if (!active && visible[0]) this.select(visible[0].dataset.tab);
      }

      select(name) {
        this.tabs.forEach((t) => {
          t.classList.toggle('is-active', t.dataset.tab === name);
          t.setAttribute('aria-selected', t.dataset.tab === name);
        });
        this.querySelectorAll('[data-pane]').forEach((p) => (p.hidden = p.dataset.pane !== name));
      }

      async onClick(e) {
        const size = e.target.closest('[data-mini-size]');
        const row = e.target.closest('[data-mini]');
        if (size && row) {
          row.querySelectorAll('[data-mini-size]').forEach((s) => s.classList.toggle('is-selected', s === size));
          const add = row.querySelector('[data-mini-add]');
          add.dataset.variant = size.dataset.miniSize;
          add.disabled = false;
          add.textContent = 'Tilføj til kurv';
          return;
        }
        const add = e.target.closest('[data-mini-add]');
        if (add && add.dataset.variant && window.mbaAddToCart) {
          add.disabled = true;
          try {
            await window.mbaAddToCart(add.dataset.variant);
            add.textContent = 'Lagt i kurv ✓';
          } catch (err) {
            add.textContent = err.message;
          } finally {
            add.disabled = false;
          }
        }
      }
    }
  );
}

// "Køb nu": add the selected variant + quantity to the cart, then go straight to checkout
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-mba-buynow]');
  if (!button) return;
  const form = button.closest('form');
  if (!form) return;
  button.disabled = true;
  button.classList.add('is-loading');
  try {
    const response = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    if (!response.ok) throw new Error();
    window.location.href = '/checkout';
  } catch (e) {
    button.disabled = false;
    button.classList.remove('is-loading');
  }
});

// "Læs mere" under the intro: open + scroll to the Beskrivelse accordion
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-open-acc]');
  if (!link) return;
  const acc = document.getElementById(link.dataset.openAcc);
  if (!acc) return;
  event.preventDefault();
  acc.open = true;
  acc.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

// Mobile gallery: replace "‹ 1/4 ›" with a segmented progress bar (same look as the product cards)
(() => {
  const init = () => {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const list = gallery.querySelector('.product__media-list');
      if (!list || gallery.querySelector('.mba-gbar')) return;
      const slides = [...list.querySelectorAll('.product__media-item')].filter((s) => s.offsetParent !== null || s.classList.contains('slider__slide'));
      if (slides.length < 2) return;
      const bar = document.createElement('div');
      bar.className = 'mba-gbar';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = slides.map(() => '<span></span>').join('');
      list.closest('slider-component').after(bar);
      const segs = bar.querySelectorAll('span');
      const update = () => {
        const w = list.clientWidth || 1;
        const visible = [...list.querySelectorAll('.product__media-item')].filter((s) => s.offsetWidth > 0);
        const idx = Math.min(visible.length - 1, Math.round(list.scrollLeft / (visible[0] ? visible[0].offsetWidth || w : w)));
        segs.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      };
      list.addEventListener('scroll', update, { passive: true });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
